import React, {Component} from 'react';
import {connect} from 'react-redux';
import {submit} from 'redux-form';
import PropTypes from 'prop-types';

import {FormAsyncButton} from "./AsyncButton";

class RemoteSubmitButton extends Component {
    render() {
        const {submitting, syncErrors, handleSubmit, block, color, outline, size, style} = this.props;
        return (
            <FormAsyncButton
                type="button"
                acting={!!submitting}
                onClick={handleSubmit}
                style={style}
                outline={outline}
                size={size}
                color={color}
                block={block}
                disabled={syncErrors}
            >
                {this.props.children}
            </FormAsyncButton>
        );
    }
}

RemoteSubmitButton.propTypes = {
    formName: PropTypes.string.isRequired,
    block: PropTypes.bool,
    color: PropTypes.string,
    outline: PropTypes.bool,
    size: PropTypes.string,
    style: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    const form = state.form[props.formName];
    return {
        submitting: form && form.submitting,
        syncErrors: form && !!form.syncErrors,
    };
};

const mapDispatchToProps = (dispatch, props) => ({
    handleSubmit() {
        return dispatch(submit(props.formName));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoteSubmitButton);


// WEBPACK FOOTER //
// ./src/components/controls/buttons/RemoteSubmitButton.js